var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sideNav"}},[_c('div',{staticClass:"item icon iconf-code"}),_c('div',{staticClass:"item icon iconf-customer"}),_c('div',{staticClass:"item icon iconf-pin",on:{"click":_vm.scrollTo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }